import { ExchangeSearchParamsSectors, SectorChangeTrip, SectorTripNumber } from '@user-history/entities/user-history-item';
import { getDeparturePoint } from '@search-bar/mappers/exchange-url.mapper';
import { ReservationFlight } from '@user-history/entities/history-booking-detail';
import { SectorChangeTripEvent } from '@shared/travel-etas/entities/sector-exchange-event';
import { isNullOrUndefined } from '@app/util/util';
import { AirSearchPayloadTrips } from '@flight-results/entities/airSearchPayload';

export const TIME_SEPARATOR_DATE = ':';

export function exchangeDisabledSector(
  event: SectorChangeTripEvent,
  allReservations: ReservationFlight[],
): SectorChangeTrip[] {
  const changes = event?.sectors;
  const sectors = event?.reservation?.Sectors;
  const anotherSectors: SectorChangeTrip[] = [];
  if (allReservations?.length === 1) {
    if (changes.length === sectors.length) return anotherSectors;
    else {
      sectors.forEach(sector => {
        const inExchange = changes.find(change => change.SectorNumber === sector.SectorNumber);
        if (!inExchange) {
          anotherSectors.push({
            SectorNumber: sector.SectorNumber,
            DeparturePoint: sector.Flights[0].DepartureAirport,
            ArrivalPoint: sector.Flights[sector.Flights.length - 1].ArrivalAirport,
            DepartureDate: sector.Flights[0].DepartureDate,
            SectorChange: false,
            ReservationIndex: 0,
          });
        }
      });
      return anotherSectors;
    }
  } else {
    const opposite = allReservations.find(all => all.Id !== event?.reservation?.Id);
    const oppositeIndex = allReservations.findIndex(all => all.Id !== event?.reservation?.Id);
    opposite.Sectors.forEach(sector => {
      anotherSectors.push({
        SectorNumber: sector.SectorNumber,
        DeparturePoint: sector.Flights[0].DepartureAirport,
        ArrivalPoint: sector.Flights[sector.Flights.length - 1].ArrivalAirport,
        DepartureDate: sector.Flights[0].DepartureDate,
        SectorChange: false,
        ReservationIndex: oppositeIndex,
      });
    });
    return anotherSectors;
  }
}

export function disabledDepartureDate(
  data: ExchangeSearchParamsSectors, isOnlyArrival: boolean, isOneWay: boolean
): boolean {
  const trip = getTrip(data, isOnlyArrival, isOneWay);
  return isDisabledByDate(new Date(trip?.DepartureDate));
}

export function departureDateTime(
  data: ExchangeSearchParamsSectors, isOnlyArrival: boolean, isOneWay: boolean
): string {
  const trip = getTrip(data, isOnlyArrival, isOneWay);
  const date = new Date(trip.DepartureDate);
  const seconds = date.getSeconds();
  const minutes = date.getMinutes();
  const hour = date.getHours();
  const h = hour < 10 ? `0${hour}` : hour;
  const m = minutes < 10 ? `0${minutes}` : minutes;
  const s = seconds < 10 ? `0${seconds}` : seconds;
  return `${h}_${m}_${s}`;
}

export function arrivalDateTime(
  data: ExchangeSearchParamsSectors, isOnlyArrival: boolean, isOneWay: boolean
): string {
  const arrival = isOnlyArrival || !isOneWay ?
    data?.Trips?.find(trip => trip.SectorNumber === SectorTripNumber.RETURN) : null;
  if (arrival) {
    const date = new Date(arrival.DepartureDate);
    const seconds = date.getSeconds();
    const minutes = date.getMinutes();
    const hour = date.getHours();
    const h = hour < 10 ? `0${hour}` : hour;
    const m = minutes < 10 ? `0${minutes}` : minutes;
    const s = seconds < 10 ? `0${seconds}` : seconds;
    return `${h}_${m}_${s}`;
  } else return null;
}

export function getStringDateByUrl(trip: AirSearchPayloadTrips, data: ExchangeSearchParamsSectors): string {
  if (trip.SectorNumber === SectorTripNumber.DEPARTURE) {
    return `${trip.DepartureDate}T${data.originalDepartureDateTime.replace(/_/g, TIME_SEPARATOR_DATE)}`;
  } else {
    return `${trip.DepartureDate}T${data.originalArrivalDateTime.replace(/_/g, TIME_SEPARATOR_DATE)}`;
  }
}

export function isDisabledByDate(date: Date): boolean {
  const current = new Date();
  return !isNullOrUndefined(date) && current.getTime() >= new Date(date).getTime();
}

function getTrip(
  data: ExchangeSearchParamsSectors, isOnlyArrival: boolean, isOneWay: boolean
): AirSearchPayloadTrips {
  const departureTrip = isOnlyArrival ? data?.exchangeDisabledSector?.[0] :
    isOneWay ? data?.Trips?.[0] : getDeparturePoint(data);
  return isOnlyArrival ? data.exchangeDisabledSector?.[0] : departureTrip;
}
